export default "__VITE_ASSET__BH7_mn9n__"